import { Main} from './Main';
import { MPSDKInfo } from './MPSDKInfo';
import { URLHelper} from './XUtils';
import { XDebug } from './XUtils';

// ===== 基本設定
window.name = 'Osaka-U_IST-VR';
//バージョン
const version = 'v0.1.0'; //Last update: 2021/04/28
const xdebug = new XDebug();

// declare this file is a module
export { };

// augment window with the MP_SDK property
declare global {
  interface Window {
    MP_SDK: any;
  }
}

// Debug Output
let debugLvl = 3;
let outStamp = false;
// SDK Key
let sdkInfo = new MPSDKInfo();
const key = sdkInfo.keys[3].sdk;  //'2527fp0png0irnqci21uhspud'
const sdkVersion = sdkInfo.versions[1]; //3.10
if(debugLvl > 0) console.log("SDK Key & version", key, sdkVersion);


// ===== Pre-Process
//URLとクエリパラメータの取得
let urlHelper = new URLHelper();
if(debugLvl > 0) console.log(urlHelper.getFullURL());
const loc = urlHelper.getParamByName('loc');  // CustomLocationData.locationSetsの要素の'name'（場所） 10,21,22,など
if(debugLvl > 0) console.log('loc='+loc);

// Matterport Space IDの取得（iframeから）
const psrc = document.getElementById('showcase')['src']; //iframeタグのsrcパラメター
const mpparams = urlHelper.getParamObject(psrc);  // iframeタグのsrcパラメータのクエリパラメータを取得
const spaceid = mpparams['m']; // Matterport SpaceのID
if(debugLvl > 0) console.log('m='+ spaceid);

// 開発環境か本番環境か
let deploy:'development'|'production';
if(urlHelper.isLocalHost()){
  deploy = 'development';
}else{
  deploy = 'production';
  debugLvl = 0; //本番環境ではデバッグ出力しない
}
if(debugLvl > 0) console.log(debugLvl, deploy);

// Matterport Showcase要素の取得
const showcase = document.getElementById('showcase') as HTMLIFrameElement;    //contentWindowを使うため、HTMLIFrameElementにキャスト
if(outStamp) {
  //タイムスタンプとバージョンの出力
  document.getElementById('timestamp').innerText = xdebug.GetTimeStamp();
  document.getElementById('version').innerText = version;
}

// MP SDKの読込み〜コールバック
showcase.addEventListener('load', async function () {
  let mpSdk;
  try {
    mpSdk = await showcase.contentWindow.MP_SDK.connect(showcase, key, sdkVersion);
  }
  catch (e) {
    console.error(e);
    return;
  }
  //メインルーチンへ
  const overlay = document.getElementById('overlay') as HTMLElement; 
  if(overlay != null) {
    overlay.style.display = 'block';
    overlay.style.visibility = 'visible';
  }
  
  const main = new Main(mpSdk, deploy, debugLvl, spaceid, loc);
  main.StartTracking();
});


